import { useState, Fragment, useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import { Modal, Nav } from "react-bootstrap";
import LoginForm from "../../components/login-form/login-form.component";
import AuthUser from "../../services/AuthUser";
import { API_URL } from "../../shared/constant";
import Logo from "../../assets/header-logo.png";
import { NotificationManager } from "react-notifications";
import { SiteContext } from "../../contexts/site-context";
import "./header.styles.scss";
const HeaderGuest = () => {
  const { siteSettings } = useContext(SiteContext);
  const [loginShow, setLoginShow] = useState(false);
  const [isNavExpanded, setIsNavExpanded] = useState(false);
  const { http, setToken } = AuthUser();
  const handleLoginShow = () => setLoginShow(true);
  const handleLoginClose = () => setLoginShow(false);

  const onLoginFormSubmit = (data) => {
    http
      .post(API_URL.LOGIN, { username: data.username, password: data.password })
      .then((res) => {
        if (res.data.code === 200) {
          setToken(res.data.data, res.data.token);
          NotificationManager.success(
            "You have successfully logged in!",
            "Successful!",
            2000
          );
        } else {
          NotificationManager.error(res.data.msg, "Error!");
        }
      })
      .catch((err) => {
        NotificationManager.error("Error while login!", "Error!");
      });
  };

  const location = useLocation();

  //destructuring pathname from location
  const { pathname } = location;
  const splitLocation = pathname.split("/");
  return (
    <Fragment>
      <header
        className={`header-nav menu_style_home_one style2 home10 navbar-scrolltofixed stricky main-menu ${
          splitLocation[1] === "property" && splitLocation[2] !== ""
            ? "listing_single_page5"
            : ""
        }`}
      >
        <div className="container p0">
          <Nav>
            <div className="menu-toggle">
              <div className="menubar-wrapper">
                <button
                  type="button"
                  id="menu-btn"
                  onClick={() => {
                    setIsNavExpanded(!isNavExpanded);
                  }}
                >
                  <span></span>
                </button>
                <Link to="/" className="navbar_brand float-left db-xsd">
                  <img
                    className="logo img-fluid"
                    src={
                      siteSettings && siteSettings.general_info.logo
                        ? siteSettings.general_info.logo
                        : Logo
                    }
                    alt="CentralTx"
                    width="40px"
                  />
                  <span>CentralTX</span>
                </Link>
                <Link to="#" onClick={handleLoginShow}>
                  <span className="flaticon-user"></span>
                </Link>
              </div>
            </div>
            <Link to="/" className="navbar_brand float-left dn-xsd">
              <img
                className="logo img-fluid"
                src={
                  siteSettings && siteSettings.general_info.logo
                    ? siteSettings.general_info.logo
                    : Logo
                }
                alt="CentralTx"
                width="40px"
              />
              <span>CentralTX</span>
            </Link>
            <ul
              id="respMenu"
              className={
                isNavExpanded
                  ? "ace-responsive-menu text-left expanded"
                  : "ace-responsive-menu text-left"
              }
              data-menu-style="horizontal"
            >
              <li className={splitLocation[1] === "" ? "active" : ""}>
                <Link to="/" onClick={() => setIsNavExpanded(false)}>
                  <span className="title">Home</span>
                </Link>
              </li>
              <li className={splitLocation[1] === "about" ? "active" : ""}>
                <Link to="/about" onClick={() => setIsNavExpanded(false)}>
                  <span className="title">About</span>
                </Link>
              </li>
              <li className={splitLocation[1] === "property" ? "active" : ""}>
                <Link to="/property" onClick={() => setIsNavExpanded(false)}>
                  <span className="title">Property</span>
                </Link>
              </li>
              <li className={splitLocation[1] === "team" ? "active" : ""}>
                <Link to="/team" onClick={() => setIsNavExpanded(false)}>
                  <span className="title">Team</span>
                </Link>
              </li>
              <li
                className={
                  splitLocation[1] === "contact" ? "last active" : "last"
                }
              >
                <Link to="/contact" onClick={() => setIsNavExpanded(false)}>
                  <span className="title">Contact</span>
                </Link>
              </li>
              <li className="list-inline-item list_s float-right dn-xsd">
                <Link
                  to="#"
                  className="btn flaticon-user"
                  onClick={handleLoginShow}
                >
                  <span>Login</span>
                </Link>
              </li>
            </ul>
          </Nav>
        </div>
      </header>
      <Modal
        show={loginShow}
        onHide={handleLoginClose}
        className="loginModal"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Body>
          <LoginForm onSubmit={onLoginFormSubmit} />
        </Modal.Body>
      </Modal>
    </Fragment>
  );
};

export default HeaderGuest;
